const statusSiteUserPublisher = {
  PENDING: "در حال انتظار",
  REJECT: "رد شده",
  CONFIRM: "تایید شده",
  PENDING_EDIT: "در حال انتظار ویرایش",
  REJECT_EDIT: "تایید شده - آخرین ویرایش رد شده ",
};

export default {
  statusSiteUserPublisher,
};
